import React from 'react';

export interface TableData {
  title?: string;
  columns: string[];
  rows: (string | number)[][];
}

interface TableRendererProps {
  tableData: TableData;
}

export const TableRenderer: React.FC<TableRendererProps> = ({ tableData }) => {
  const { title, columns = [], rows = [] } = tableData || ({} as TableData);

  if (!rows || rows.length === 0) {
    return null;
  }

  return (
    <div className="table-wrapper">
      {title && <h4 className="table-title">{title}</h4>}
      <div className="table-scroll">
        <table className="data-table">
          {columns.length > 0 && (
            <thead>
              <tr>
                {columns.map((col, i) => (
                  <th key={i}>{col}</th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {rows.map((row, ri) => (
              <tr key={ri}>
                {row.map((cell, ci) => (
                  <td key={ci}>{cell as React.ReactNode}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
